// extracted by mini-css-extract-plugin
export default {"form":"ExportData_form__8qhku"};